import { Component, OnInit, ViewEncapsulation, Input, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { DeviceService } from '../../providers/device.service';
import { HorizontalScrollService } from './horizontal-scroll.service';
import { AutoSub, AutoSubOnDestroy } from '../../providers';
import * as smoothscroll from "smoothscroll-polyfill";

@AutoSubOnDestroy()
@Component({
    selector: 'horizontal-scroll',
    templateUrl: './horizontal-scroll.component.html',
    styleUrls: ['./horizontal-scroll.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class HorizontalScrollComponent implements OnInit, AfterViewInit {

    @ViewChild('scrollContainer', { static: true }) scrollContainer: ElementRef<HTMLDivElement>;

    public disableLeftArrow: boolean = true;
    public disableRightArrow: boolean = true;

    @Input() key: string = "";
    @Input() header: string = "";

    constructor(private device: DeviceService, private scrollService: HorizontalScrollService) {
        if(!this.device.isPlatformServer()) smoothscroll.polyfill();
    }

    ngOnInit(): void {
        // Watch any component force-updating the scroll position from scrollPositionsMap
        AutoSub(this).reg['updateSub'] = this.scrollService.watchForceUpdate().subscribe(() => {
            this.updateScrollPosition();
        })
    }

    ngAfterViewInit(): void {
        this.updateScrollPosition();
    }

    public async updateScrollPosition() {
        // The timeout ensures that the DOM has been fully drawn, and scrolling is possible (also works with 0ms)
        // It also ensures that we are allowed to update the arrows with getting a ExpressionChangedAfterItHasBeenCheckedError
        await new Promise(resolve => setTimeout(resolve, 20));

        if(!this.scrollContainer) return console.log("no scroll container");
        // Set scroller to stored scroll position if there is one, otherwise reset
        let storedScrollPos = this.scrollService.fetchScrollPosition(this.key) || 0;
        this.scrollContainer.nativeElement.scrollLeft = storedScrollPos;
        // Init arrows
        this.updateArrowDisabling(storedScrollPos);
    }

    /**
     * Called on left arrow click
     */
    public scrollLeft() {
        // Make sure that application runs in browser
        if(!window) return;
        // Calculate next scroll position and update arrow enablement
        let nextPosition = this.scrollContainer.nativeElement.scrollLeft - window.innerWidth;
        this.updateArrowDisabling(nextPosition);
        this.scrollTo(nextPosition);
    }

    /**
     * Called on right arrow click
     */
    public scrollRight() {
        // Make sure that application runs in browser
        if(!window) return;
        // Calculate next scroll position and update arrow enablement      
        let nextPosition = this.scrollContainer.nativeElement.scrollLeft + window.innerWidth;
        this.updateArrowDisabling(nextPosition);
        this.scrollTo(nextPosition);
    }

    /**
     * Disable arrows if they cannot move the scroll any further
     */
    public updateArrowDisabling(scrollPosition?: number) {
        if(scrollPosition == null) scrollPosition = this.scrollContainer.nativeElement.scrollLeft;

        let endPosition = this.scrollContainer.nativeElement.scrollWidth - this.scrollContainer.nativeElement.clientWidth;
        this.disableLeftArrow = (scrollPosition <= 10);
        this.disableRightArrow = (scrollPosition >= (endPosition - 10));
    }

    private scrollTo(position: number) {
        this.scrollContainer.nativeElement.scrollTo({
            left: position,
            behavior: 'smooth'
        });

        this.updateStoredPosition(position);
    }

    /**
     * Update stored scroller position on mouse wheel or arrow click
     */
    public updateStoredPosition(position?: any) {
        if(!position) position = this.scrollContainer.nativeElement.scrollLeft;
        this.scrollService.storeScrollPosition(this.key, position);
        this.updateArrowDisabling();
    }
}
